  <div class="filter-popup">
    <div class="filter-heading">
      <h2>Filter Staff</h2>
    </div>
    <form [formGroup]="filterForm">
      <div class="filter-row">
        <div class="filter-column">
          <div class="field">
            <p class="label">Role</p>
            <mat-form-field appearance="outline" class="filter-input">
              <input
                matInput
                [matAutocomplete]="roleAuto"
                placeholder="Search for role"
                [formControl]="roleControl"
                autocomplete="off"
                #roleAutocompleteTrigger="matAutocompleteTrigger"
              />
              <mat-autocomplete #roleAuto="matAutocomplete" (optionSelected)="onRoleChange($event)">
                <mat-option *ngFor="let role of filteredRoles" [value]="role">
                  {{ role.roleName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>       
          <div class="field">
            <p class="label">Position</p>
            <mat-form-field appearance="outline" class="filter-input">
              <input
                matInput
                [matAutocomplete]="positionAuto"
                placeholder="Search for position"
                [formControl]="positionControl"
                #positionAutocompleteTrigger="matAutocompleteTrigger"
              />
              <mat-autocomplete #positionAuto="matAutocomplete" (optionSelected)="onPositionChange($event)">
                <mat-option *ngFor="let position of filteredPositions" [value]="position">
                  {{ position.position }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="field">
            <p class="label">Status</p>
            <mat-form-field appearance="outline" class="filter-input">
              <input
                matInput
                [matAutocomplete]="statusAuto"
                placeholder="Search for status"
                [formControl]="statusControl"
                #statusAutocompleteTrigger="matAutocompleteTrigger"
              />
              <mat-autocomplete #statusAuto="matAutocomplete" (optionSelected)="onStatusChange($event)">
                <mat-option *ngFor="let status of filteredStatusTypes" [value]="status">
                  {{ status }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div *ngIf="chips?.length" class="row-container-2">
        <span class="paragraph-medium">Filters applied: </span>
        <mat-chip
          class="chip-item"
          *ngFor="let chip of chips"
          (removed)="remove(chip)"
        >
          {{ chip?.name }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </div>
      <div class="footer">
        <button mat-raised-button class="filter-btn" (click)="submitFilter()">
          Filter
        </button>
        <button mat-raised-button class="clear-btn" (click)="clearFilter()">
          Clear
        </button>
        <button mat-raised-button class="cancel-btn" (click)="cancel()">
          Clear & Cancel
        </button>
      </div>
    </form>
  </div>